
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// Updates data
const recentUpdates = [
  { id: 1, title: "RBI Circular: Digital Lending Guidelines", date: "2025-04-25", type: "regulatory" },
  { id: 2, title: "New HFC Compliance Requirements", date: "2025-04-23", type: "compliance" },
  { id: 3, title: "Updated Data Localization Rules", date: "2025-04-20", type: "regulatory" },
];

const RegulatoryUpdates: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Regulatory Updates</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {recentUpdates.map((update) => (
          <div key={update.id} className="flex justify-between items-start border-b pb-3 last:border-0">
            <div>
              <h4 className="font-medium">{update.title}</h4>
              <p className="text-sm text-muted-foreground">{update.date}</p>
            </div>
            <div className={`px-2 py-1 text-xs rounded-full ${
              update.type === 'regulatory' 
                ? 'bg-purple-100 text-purple-800' 
                : 'bg-green-100 text-green-800'
            }`}>
              {update.type}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default RegulatoryUpdates;
